function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Asset-Artboard-Page",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TWITTER-ICONS/16/TWITTER"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,3.53594932 C15.4119706,3.79660496 14.7815391,3.97490621 14.1167058,4.05486192 C14.7951398,3.64788732 15.3159658,3.00584292 15.559178,2.23986715 C14.9255463,2.61645858 14.2247112,2.88910757 13.4750738,3.03622609 C12.879044,2.39817947 12.0262013,2 11.0813541,2 C9.26846342,2 7.7979899,3.47118519 7.7979899,5.27738483 C7.7979899,5.53804047 7.8259913,5.78910142 7.8819941,6.02736946 C5.15145757,5.89144474 2.73533677,4.58256965 1.11685584,2.59886832 C0.830441522,3.08339996 0.668833442,3.64868688 0.668833442,4.24995387 C0.668833442,5.38772372 1.24966248,6.39596531 2.13050653,6.9804416 C1.59127956,6.96445046 1.08565428,6.81733194 0.642432122,6.57186789 C0.642432122,6.58625992 0.642432122,6.59985239 0.642432122,6.6126453 C0.642432122,8.2013654 1.7760888,9.5286303 3.27616381,9.82926379 C3.00095005,9.90362261 2.71133557,9.94440002 2.41372069,9.94440002 C2.19930997,9.94440002 1.9960998,9.92521065 1.79528976,9.88763147 C2.21211061,11.1901101 3.42417121,12.139984 4.86184309,12.1655698 C3.73938697,13.0450827 2.32411621,13.5727905 0.784039202,13.5727905 C0.517625881,13.5727905 0.256012801,13.5559998 0,13.5280153 C1.45047252,14.4571007 3.17935897,15 5.02985149,15 C11.0693535,15 14.3735187,9.99956947 14.3735187,5.66596962 C14.3735187,5.52364844 14.3711186,5.38132726 14.3631182,5.23980565 C15.0039502,4.77366382 15.5623781,4.19638354 16,3.53594932 Z",
  id: "Path",
  fill: "#FFFFFF"
})));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.c606d126.svg";
export { ForwardRef as ReactComponent };